import { Message } from 'element-ui'

let networkMessage = null

function updateNetworkDisplay(online) {
    console.log('network', online)
    if(online) {
        if(networkMessage) {
            networkMessage.close()
            networkMessage = null
        }
    }else {
        if(!networkMessage) {
            networkMessage = Message({
                duration: 0,
                type: 'warning',
                message: 'Network not connected!',
                center: true,
                showClose: true,
                onClose: () => {
                    networkMessage = null
                }
            })
        }
    }
}

// function checkNetworkByConnection() {
//     const netWorkDownlink = navigator.connection.downlink

//     if (navigator.connection && navigator.connection.onchange === null) {
//         navigator.connection.onchange=() => {
//             if (netWorkDownlink !== navigator.connection.downlink || navigator.connection.rtt === 0) {
//                 console.log('connection', false)
//                 updateNetworkDisplay(false)
//             } else if (netWorkDownlink === navigator.connection.downlink || navigator.connection.rtt !== 0) {
//                 console.log('connection', true)
//                 updateNetworkDisplay(true)
//             }
//         }
//     }
// }

function checkNetworkByOnLine() {
    window.addEventListener('online', () => {
        console.log('online')
        updateNetworkDisplay(navigator.onLine)
    })
    window.addEventListener('offline', () => {
        console.log('offline')
        updateNetworkDisplay(navigator.onLine)
    });
}

// checkNetworkByConnection()
checkNetworkByOnLine()
